// @ts-nocheck

import React, { useEffect } from 'react';
import styled from 'styled-components';

import { AutoScrollAnchor } from '../../styled-components/shared';
import { smoothScrollToAnchor } from '../../utils/smoothScroll';
import MobileSportsMenuContainer from '../MobileSportsMenu/MobileSportsMenuContainer';
import SearchBarContainer from '../SearchBar/SearchBarContainer';

const Wrapper = styled.div`
  height: 100%;
  background: #000;
  padding: 0.3em 0.5em;
  color: white;
`;

type MobileSportsRouteViewPropsType = {
  isSearching: boolean;
};

export const SPORTS_ROUTE_ANCHOR_ID = 'sports-route-anchor';

const MobileSportsRouteView = ({ isSearching }: MobileSportsRouteViewPropsType) => {
  useEffect(() => {
    smoothScrollToAnchor(SPORTS_ROUTE_ANCHOR_ID);
  }, []);

  return (
    <Wrapper>
      <AutoScrollAnchor data-anchorid={SPORTS_ROUTE_ANCHOR_ID} />
      <SearchBarContainer />
      {!isSearching ? <MobileSportsMenuContainer /> : null}
    </Wrapper>
  );
};

export default MobileSportsRouteView;
